import * as QuotaAction from "./QuotaAction";

export default function quotaReducer(state = {}, action) {
    switch (action.type) {
        case QuotaAction.REQUEST_ALL_QUOTAS_FINISHED:
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    allQuotas: {
                        ...action.payload
                    }
                };
            }
        case QuotaAction.REQUEST_QUOTA_FINISHED:
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                const id = action.payload?.id
                return {
                    ...state,
                    allQuotas: {
                        [id]: action.payload
                    }
                };
            }

        case QuotaAction.REQUEST_QUOTA_ORDERS_FINISHED:
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    orders: {
                        ...action.payload
                    }
                };
            }

        case QuotaAction.REQUEST_USER_QUOTA_FINISHED:
            if (action.payload.errors) {
                return {
                    ...state,
                    userQuota: null
                };
            } else {
                return {
                    ...state,
                    userQuota: {
                        ...action.payload
                    }
                };
            }

        default:
            return state;
    }
}
